"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("./Container"));

var _Aside = _interopRequireDefault(require("./Aside"));

var _TracksContent = _interopRequireDefault(require("./TracksContent"));

var _Track = _interopRequireDefault(require("./Track"));

var _model = require("./model");

var _ga = require("../services/ga");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO add to cms boolean flag to ignore event click
var IGNORE_CLICK_EVENT_SLUGS = ['day-1-closing-ceremony', 'day-2-closing-ceremony', 'break', 'conference-opening', 'day-1-opening', 'day-2-opening', 'day-3-opening', 'opening-ceremony', 'coffee-break', 'closing-ceremony'];

var getGroupedTracks = function getGroupedTracks(tracks) {
  return tracks.reduce(function (resultTracks, currentTrack) {
    var separatedTracks = currentTrack.list.reduce(function (tracksMap, event) {
      var result = _objectSpread({}, tracksMap);

      if (result[event.subTrackIndex]) {
        result[event.subTrackIndex].list.push(event);
      } else {
        result[event.subTrackIndex] = _objectSpread(_objectSpread({}, currentTrack), {}, {
          isPrimaryTrack: event.subTrackIndex === 'default',
          title: event.subTrackIndex === 'default' || !event.subTrackIndex ? currentTrack.title : '',
          list: [event]
        });
      }

      return result;
    }, {});
    return [].concat(_toConsumableArray(resultTracks), _toConsumableArray(Object.values(separatedTracks)));
  }, []);
};

var getFlatTrackList = function getFlatTrackList(tracksList) {
  return tracksList.reduce(function (result, item) {
    if (Array.isArray(item.list)) {
      return result.concat(getFlatTrackList(item.list));
    }

    return result.concat(item);
  }, []);
};

var getTracksForSingleDay = function getTracksForSingleDay(scheduleDay) {
  return scheduleDay.list.reduce(function (acc, trackData) {
    var trackTitleKey = trackData.track.trim().toLowerCase();

    if (acc[trackTitleKey]) {
      acc[trackTitleKey].list = acc[trackTitleKey].list.concat(getFlatTrackList(trackData.list));
    } else {
      acc[trackTitleKey] = {
        title: trackData.track,
        list: getFlatTrackList(trackData.list)
      };
    }

    return acc;
  }, {});
};

var getTracksForAllDays = function getTracksForAllDays(emsSchedule) {
  var tracksResultObject = emsSchedule.reduce(function (acc, scheduleDay) {
    var tracksForSingleDay = getTracksForSingleDay(scheduleDay);
    Object.keys(tracksForSingleDay).forEach(function (track) {
      if (acc[track]) {
        acc[track].list = acc[track].list.concat(tracksForSingleDay[track].list);
      } else {
        acc[track] = tracksForSingleDay[track];
      }
    });
    return acc;
  }, {});
  return Object.values(tracksResultObject);
};

var App = function App(_ref) {
  var bus = _ref.bus;
  var content = bus.getContent();
  var defaultCustomTracks = content.customTracks,
      defaultSchedule = content.schedule,
      scheduleOffline = content.scheduleOffline,
      _content$isOfflineTim = content.isOfflineTimeTrack,
      isOfflineTimeTrack = _content$isOfflineTim === void 0 ? false : _content$isOfflineTim,
      _content$isOfflineJSN = content.isOfflineJSNTimeTrack,
      isOfflineJSNTimeTrack = _content$isOfflineJSN === void 0 ? false : _content$isOfflineJSN,
      eventInfo = content.eventInfo,
      isAuth = content.isAuth,
      availableTracks = content.availableTracks,
      speakers = content.speakers,
      emsSchedule = content.emsSchedule,
      emsScheduleOffline = content.emsScheduleOffline,
      tracksOrdered = content.tracksOrdered;
  var schedule = defaultSchedule;
  var customTracks = defaultCustomTracks;
  var formattedMainTracks = [];
  var formattedCustomTracks = [];

  if (emsSchedule || emsScheduleOffline) {
    var scheduleTracks = getTracksForAllDays(emsSchedule);
    schedule = scheduleTracks; // HARDCODE JSN/RS 2023 (show offline schedule of either sOfflineTimeTrack || isOfflineJSNTimeTrack is true)

    if ((isOfflineTimeTrack || isOfflineJSNTimeTrack) && emsScheduleOffline) {
      var scheduleOfflineTracks = getTracksForAllDays(emsScheduleOffline);
      schedule = scheduleOfflineTracks; // hide custom customTracks for offline conference

      customTracks = [];
    }

    formattedMainTracks = tracksOrdered ? tracksOrdered.map(function (track) {
      return schedule.find(function (s) {
        return s.title === track;
      });
    }) : schedule; // remove when migrate all data to ems

    formattedCustomTracks = [];
  } else {
    // HARDCODE RS 2022
    if (isOfflineTimeTrack) {
      schedule = [scheduleOffline[0], scheduleOffline[1]];
      customTracks = [scheduleOffline[2], scheduleOffline[3]];
    } // HARDCODE JSN 2022


    if (isOfflineJSNTimeTrack) {
      schedule = [scheduleOffline[0], scheduleOffline[1]];
      customTracks = [scheduleOffline[2]];
    }

    formattedMainTracks = getGroupedTracks(schedule);
    formattedCustomTracks = getGroupedTracks(customTracks);
  }

  var chatLink = eventInfo.chatLink,
      chatLinkAuth = eventInfo.chatLinkAuth,
      defaultStartTime = eventInfo.conferenceStart,
      endTime = eventInfo.conferenceFinish;
  var startTime = defaultStartTime; // HARDCODE RS 2023

  if (isOfflineTimeTrack) {
    startTime = '2023-06-02T06:00:00+00:00';
  } // HARDCODE JSN 2023


  if (isOfflineJSNTimeTrack) {
    startTime = '2023-06-01T06:00:00+00:00';
  }

  var timeTicks = (0, _model.createTimeTicks)(startTime, endTime);
  var calcPosition = (0, _model.calcPositionFromTime)(startTime);
  var trackWidth = calcPosition({
    isoDate: endTime
  });

  var handleClick = function handleClick(eventContent) {
    var _eventContent$subacti, _payload$data;

    // HARDCODE RS 2022
    if (isOfflineTimeTrack) {
      return;
    } // HARDCODE JSN 2022


    if (isOfflineJSNTimeTrack) {
      return;
    }

    if (IGNORE_CLICK_EVENT_SLUGS.includes(eventContent.slug)) {
      return;
    }

    var isTrackAvailable = true; // some conferences may provide availableTracks: Array<string>

    if (availableTracks) {
      isTrackAvailable = availableTracks.includes(eventContent.trackTitle);
    }

    var correctDiscordLink = isAuth ? chatLinkAuth : chatLink;
    var payload = {
      data: _objectSpread(_objectSpread({}, eventContent), {}, {
        /* TODO: switch to real date */
        date: eventContent.date || eventContent.track
      }),
      isAuth: isAuth,
      name: 'any-room',
      link: eventContent.roomLink || eventContent.discussionRoomLink || eventContent.additionalLink || correctDiscordLink
    };

    if (eventContent.isQaEvent || eventContent.eventType === 'PanelDiscussion') {
      payload.isAuth = true;
      payload.link = isAuth ? chatLinkAuth : chatLink;
    }

    if (eventContent.speaker && isTrackAvailable && speakers) {
      var speakerData = speakers.main.find(function (s) {
        return s.name.trim().toLowerCase() === eventContent.speaker.trim().toLowerCase();
      });
      payload.name = 'speaker-card';
      payload.data = speakerData;
    } // TODO make type_id for events in db schema


    if (!eventContent.roomLink && !eventContent.discussionRoomLink && !eventContent.speaker && !correctDiscordLink) {
      payload.isAuth = true;
    }

    if ((eventContent.lightningTalks || ((_eventContent$subacti = eventContent.subactivities) === null || _eventContent$subacti === void 0 ? void 0 : _eventContent$subacti.length) > 0) && isTrackAvailable) {
      payload.name = 'lightning-talks';
      payload.data.lightningTalks = eventContent.isLightning ? eventContent.subactivities : eventContent.lightningTalks;
    }

    (0, _ga.trackGAEvent)('TT', 'CL', payload === null || payload === void 0 ? void 0 : (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.slug, isAuth);
    bus.clickEvent(payload);
  };

  return /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_Aside.default, {
    schedule: formattedMainTracks,
    customTracks: formattedCustomTracks
  }), /*#__PURE__*/_react.default.createElement(_TracksContent.default, {
    timeTicks: timeTicks,
    trackWidth: trackWidth,
    calcPosition: calcPosition
  }, formattedMainTracks.map(function (sch, i) {
    return /*#__PURE__*/_react.default.createElement(_Track.default, {
      key: "".concat(sch.title, "-").concat(i),
      track: sch,
      calcPosition: calcPosition,
      onClick: handleClick
    });
  }), formattedCustomTracks.map(function (tr, i) {
    return /*#__PURE__*/_react.default.createElement(_Track.default, {
      key: "".concat(tr.title, "-").concat(i),
      track: tr,
      calcPosition: calcPosition,
      onClick: handleClick
    });
  })));
};

var _default = App;
exports.default = _default;